import React, { FunctionComponent, memo } from 'react'

import { SpaceProps, WidthProps } from 'styled-system'

import { InputSmallText } from '@/atoms/typography'
import { Space } from '@/styles'

import { HiddenRadio, RadioWrapper, StyledRadio } from './atoms'

interface Props {
  value: string | boolean | number | { [key: string]: string | number | boolean }
  name: string
  id: string
  radioLabel: string | React.JSX.Element
  onClick: (value: string | boolean | number | { [key: string]: string | number | boolean }) => void
  selected: boolean
  hasError: boolean
  vertical: boolean
  optionProps?: WidthProps | SpaceProps
  disabled?: boolean
}

const Radio: FunctionComponent<Props> = ({
  id,
  onClick,
  radioLabel,
  selected,
  value,
  name,
  vertical,
  hasError,
  optionProps,
  disabled = false,
}) => {
  const handleClick = (): void => {
    if (!disabled) {
      onClick && onClick(value)
    }
  }

  return (
    <RadioWrapper onClick={handleClick} $disabled={disabled} $vertical={vertical} {...optionProps}>
      <HiddenRadio type="radio" value={value.toString()} onChange={() => null} name={name} id={id} />
      <StyledRadio $selected={selected} $hasError={hasError} />
      <InputSmallText as="label" htmlFor={name} pl={Space.S8}>
        {radioLabel}
      </InputSmallText>
    </RadioWrapper>
  )
}

export default memo(Radio)
